import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { ApiKeysGetPayload } from 'Interfaces/ApiKey';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: ApiKeysGetPayload) =>
    $actions.apiKey.getApiKeys(dispatch, payload),
  );
};
